/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router';

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as IndexImport } from './routes/index';
import { Route as InviteInviteIdImport } from './routes/invite.$inviteId';
import { Route as ConversationConversationIdImport } from './routes/conversation.$conversationId';
import { Route as AdminAdminImport } from './routes/admin/_admin';
import { Route as ClubOwnerIdOnboardImport } from './routes/clubOwner/$id/_onboard';
import { Route as ClubOwnerIdClubImport } from './routes/clubOwner/$id/_club';
import { Route as ArtistIdOnboardImport } from './routes/artist/$id/_onboard';
import { Route as ArtistIdArtistImport } from './routes/artist/$id/_artist';
import { Route as AdminAdminRegisterRequestsImport } from './routes/admin/_admin/register-requests';
import { Route as AdminAdminKanbanImport } from './routes/admin/_admin/kanban';
import { Route as AdminAdminGlobalEventsImport } from './routes/admin/_admin/global-events';
import { Route as AdminAdminClubsImport } from './routes/admin/_admin/clubs';
import { Route as AdminAdminChatImport } from './routes/admin/_admin/chat';
import { Route as AdminAdminArtistsImport } from './routes/admin/_admin/artists';
import { Route as ArtistIdCurrentWorkRouteImport } from './routes/artist/$id/current-work/route';
import { Route as AuthAuthLoginRouteImport } from './routes/_auth/auth/login/route';
import { Route as ClubOwnerIdWorkRequestWorkRequestIdImport } from './routes/clubOwner/$id/work-request.$workRequestId';
import { Route as ClubOwnerIdWorkInviteWorkInviteIdImport } from './routes/clubOwner/$id/work-invite.$workInviteId';
import { Route as ClubOwnerIdProfileprofileImport } from './routes/clubOwner/$id/profile_/_profile';
import { Route as ClubOwnerIdProfileInfoProfileIdImport } from './routes/clubOwner/$id/profile-info.$profileId';
import { Route as ClubOwnerIdEmployerWorkItemIdImport } from './routes/clubOwner/$id/employer.$workItemId';
import { Route as ClubOwnerIdClubChatImport } from './routes/clubOwner/$id/_club/chat';
import { Route as ArtistIdWorkRequestWorkRequestIdImport } from './routes/artist/$id/work-request.$workRequestId';
import { Route as ArtistIdWorkInviteWorkInviteIdImport } from './routes/artist/$id/work-invite.$workInviteId';
import { Route as ArtistIdProfileprofileImport } from './routes/artist/$id/profile_/_profile';
import { Route as ArtistIdProfileInfoClubIdImport } from './routes/artist/$id/profile-info.$clubId';
import { Route as ArtistIdArtistSearchImport } from './routes/artist/$id/_artist/search';
import { Route as ArtistIdArtistChatImport } from './routes/artist/$id/_artist/chat';
import { Route as AuthAuthRegisterRegisterRouteImport } from './routes/_auth/auth/register_/register/route';
import { Route as AuthAuthRegisterConfirmationRouteImport } from './routes/_auth/auth/register_/confirmation/route';
import { Route as AuthAuthForgotPasswordResetRouteImport } from './routes/_auth/auth/forgot-password_/reset/route';
import { Route as AuthAuthForgotPasswordEmailRouteImport } from './routes/_auth/auth/forgot-password_/email/route';
import { Route as AuthAuthForgotPasswordConfirmationRouteImport } from './routes/_auth/auth/forgot-password_/confirmation/route';
import { Route as ClubOwnerIdClubSearchIndexImport } from './routes/clubOwner/$id/_club/search/index';
import { Route as ClubOwnerIdOnboardOnboardStepImport } from './routes/clubOwner/$id/_onboard/onboard.$step';
import { Route as ClubOwnerIdClubProfileprofileImport } from './routes/clubOwner/$id/_club/profile_/_profile';
import { Route as ArtistIdOnboardOnboardStepImport } from './routes/artist/$id/_onboard/onboard.$step';
import { Route as ArtistIdArtistProfileprofileImport } from './routes/artist/$id/_artist/profile_/_profile';
import { Route as AdminAdminChatConversationConversationIdImport } from './routes/admin/_admin/chat.conversation.$conversationId';
import { Route as ClubOwnerIdProfileprofileTermsRouteImport } from './routes/clubOwner/$id/profile_/_profile/terms/route';
import { Route as ClubOwnerIdClubProfileprofileIndexImport } from './routes/clubOwner/$id/_club/profile_/_profile/index';
import { Route as ArtistIdArtistProfileprofileIndexImport } from './routes/artist/$id/_artist/profile_/_profile/index';

// Create Virtual Routes

const AdminImport = createFileRoute('/admin')();
const PrivacyPolicyLazyImport = createFileRoute('/privacy-policy')();
const ClubLazyImport = createFileRoute('/_club')();
const AuthLazyImport = createFileRoute('/_auth')();
const ClubOwnerIdImport = createFileRoute('/clubOwner/$id')();
const ArtistIdImport = createFileRoute('/artist/$id')();
const InviteRoleLazyImport = createFileRoute('/invite/role')();
const ClubOwnerIdProfileImport = createFileRoute('/clubOwner/$id/profile_')();
const ArtistIdProfileImport = createFileRoute('/artist/$id/profile_')();
const ClubOwnerIdClubProfileImport = createFileRoute(
  '/clubOwner/$id/_club/profile_'
)();
const ArtistIdArtistProfileImport = createFileRoute(
  '/artist/$id/_artist/profile_'
)();
const ClubOwnerIdProfileprofilePortfolioRouteLazyImport = createFileRoute(
  '/clubOwner/$id/profile_/_profile/portfolio'
)();
const ClubOwnerIdProfileprofileNotificationsRouteLazyImport = createFileRoute(
  '/clubOwner/$id/profile_/_profile/notifications'
)();
const ClubOwnerIdProfileprofileLoyaltyRouteLazyImport = createFileRoute(
  '/clubOwner/$id/profile_/_profile/loyalty'
)();
const ClubOwnerIdProfileprofileLanguageRouteLazyImport = createFileRoute(
  '/clubOwner/$id/profile_/_profile/language'
)();
const ClubOwnerIdProfileprofileInfoRouteLazyImport = createFileRoute(
  '/clubOwner/$id/profile_/_profile/info'
)();
const ClubOwnerIdProfileprofileEmployersRouteLazyImport = createFileRoute(
  '/clubOwner/$id/profile_/_profile/employers'
)();
const ClubOwnerIdProfileprofileAplicationsRouteLazyImport = createFileRoute(
  '/clubOwner/$id/profile_/_profile/aplications'
)();
const ArtistIdProfileprofilePortfolioRouteLazyImport = createFileRoute(
  '/artist/$id/profile_/_profile/portfolio'
)();
const ArtistIdProfileprofileNotificationsRouteLazyImport = createFileRoute(
  '/artist/$id/profile_/_profile/notifications'
)();
const ArtistIdProfileprofileLoyaltyRouteLazyImport = createFileRoute(
  '/artist/$id/profile_/_profile/loyalty'
)();
const ArtistIdProfileprofileLanguageRouteLazyImport = createFileRoute(
  '/artist/$id/profile_/_profile/language'
)();
const ArtistIdProfileprofileInfoRouteLazyImport = createFileRoute(
  '/artist/$id/profile_/_profile/info'
)();
const ArtistIdProfileprofileAplicationsRouteLazyImport = createFileRoute(
  '/artist/$id/profile_/_profile/aplications'
)();

// Create/Update Routes

const AdminRoute = AdminImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRoute
} as any);

const PrivacyPolicyLazyRoute = PrivacyPolicyLazyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRoute
} as any).lazy(() =>
  import('./routes/privacy-policy.lazy').then((d) => d.Route)
);

const ClubLazyRoute = ClubLazyImport.update({
  id: '/_club',
  getParentRoute: () => rootRoute
} as any).lazy(() => import('./routes/_club.lazy').then((d) => d.Route));

const AuthLazyRoute = AuthLazyImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute
} as any).lazy(() => import('./routes/_auth.lazy').then((d) => d.Route));

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute
} as any);

const ClubOwnerIdRoute = ClubOwnerIdImport.update({
  id: '/clubOwner/$id',
  path: '/clubOwner/$id',
  getParentRoute: () => rootRoute
} as any);

const ArtistIdRoute = ArtistIdImport.update({
  id: '/artist/$id',
  path: '/artist/$id',
  getParentRoute: () => rootRoute
} as any);

const InviteRoleLazyRoute = InviteRoleLazyImport.update({
  id: '/invite/role',
  path: '/invite/role',
  getParentRoute: () => rootRoute
} as any).lazy(() => import('./routes/invite.role.lazy').then((d) => d.Route));

const InviteInviteIdRoute = InviteInviteIdImport.update({
  id: '/invite/$inviteId',
  path: '/invite/$inviteId',
  getParentRoute: () => rootRoute
} as any).lazy(() =>
  import('./routes/invite.$inviteId.lazy').then((d) => d.Route)
);

const ConversationConversationIdRoute = ConversationConversationIdImport.update(
  {
    id: '/conversation/$conversationId',
    path: '/conversation/$conversationId',
    getParentRoute: () => rootRoute
  } as any
).lazy(() =>
  import('./routes/conversation.$conversationId.lazy').then((d) => d.Route)
);

const AdminAdminRoute = AdminAdminImport.update({
  id: '/_admin',
  getParentRoute: () => AdminRoute
} as any).lazy(() => import('./routes/admin/_admin.lazy').then((d) => d.Route));

const ClubOwnerIdProfileRoute = ClubOwnerIdProfileImport.update({
  id: '/profile_',
  path: '/profile',
  getParentRoute: () => ClubOwnerIdRoute
} as any);

const ArtistIdProfileRoute = ArtistIdProfileImport.update({
  id: '/profile_',
  path: '/profile',
  getParentRoute: () => ArtistIdRoute
} as any);

const ClubOwnerIdOnboardRoute = ClubOwnerIdOnboardImport.update({
  id: '/_onboard',
  getParentRoute: () => ClubOwnerIdRoute
} as any).lazy(() =>
  import('./routes/clubOwner/$id/_onboard.lazy').then((d) => d.Route)
);

const ClubOwnerIdClubRoute = ClubOwnerIdClubImport.update({
  id: '/_club',
  getParentRoute: () => ClubOwnerIdRoute
} as any).lazy(() =>
  import('./routes/clubOwner/$id/_club.lazy').then((d) => d.Route)
);

const ArtistIdOnboardRoute = ArtistIdOnboardImport.update({
  id: '/_onboard',
  getParentRoute: () => ArtistIdRoute
} as any).lazy(() =>
  import('./routes/artist/$id/_onboard.lazy').then((d) => d.Route)
);

const ArtistIdArtistRoute = ArtistIdArtistImport.update({
  id: '/_artist',
  getParentRoute: () => ArtistIdRoute
} as any).lazy(() =>
  import('./routes/artist/$id/_artist.lazy').then((d) => d.Route)
);

const AdminAdminRegisterRequestsRoute = AdminAdminRegisterRequestsImport.update(
  {
    id: '/register-requests',
    path: '/register-requests',
    getParentRoute: () => AdminAdminRoute
  } as any
);

const AdminAdminKanbanRoute = AdminAdminKanbanImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => AdminAdminRoute
} as any);

const AdminAdminGlobalEventsRoute = AdminAdminGlobalEventsImport.update({
  id: '/global-events',
  path: '/global-events',
  getParentRoute: () => AdminAdminRoute
} as any);

const AdminAdminClubsRoute = AdminAdminClubsImport.update({
  id: '/clubs',
  path: '/clubs',
  getParentRoute: () => AdminAdminRoute
} as any);

const AdminAdminChatRoute = AdminAdminChatImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AdminAdminRoute
} as any);

const AdminAdminArtistsRoute = AdminAdminArtistsImport.update({
  id: '/artists',
  path: '/artists',
  getParentRoute: () => AdminAdminRoute
} as any);

const ArtistIdCurrentWorkRouteRoute = ArtistIdCurrentWorkRouteImport.update({
  id: '/artist/$id/current-work',
  path: '/artist/$id/current-work',
  getParentRoute: () => rootRoute
} as any);

const AuthAuthLoginRouteRoute = AuthAuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => AuthLazyRoute
} as any).lazy(() =>
  import('./routes/_auth/auth/login/route.lazy').then((d) => d.Route)
);

const ClubOwnerIdClubProfileRoute = ClubOwnerIdClubProfileImport.update({
  id: '/profile_',
  path: '/profile',
  getParentRoute: () => ClubOwnerIdClubRoute
} as any);

const ArtistIdArtistProfileRoute = ArtistIdArtistProfileImport.update({
  id: '/profile_',
  path: '/profile',
  getParentRoute: () => ArtistIdArtistRoute
} as any);

const ClubOwnerIdWorkRequestWorkRequestIdRoute =
  ClubOwnerIdWorkRequestWorkRequestIdImport.update({
    id: '/work-request/$workRequestId',
    path: '/work-request/$workRequestId',
    getParentRoute: () => ClubOwnerIdRoute
  } as any);

const ClubOwnerIdWorkInviteWorkInviteIdRoute =
  ClubOwnerIdWorkInviteWorkInviteIdImport.update({
    id: '/work-invite/$workInviteId',
    path: '/work-invite/$workInviteId',
    getParentRoute: () => ClubOwnerIdRoute
  } as any);

const ClubOwnerIdProfileprofileRoute = ClubOwnerIdProfileprofileImport.update({
  id: '/_profile',
  getParentRoute: () => ClubOwnerIdProfileRoute
} as any);

const ClubOwnerIdProfileInfoProfileIdRoute =
  ClubOwnerIdProfileInfoProfileIdImport.update({
    id: '/profile-info/$profileId',
    path: '/profile-info/$profileId',
    getParentRoute: () => ClubOwnerIdRoute
  } as any);

const ClubOwnerIdEmployerWorkItemIdRoute =
  ClubOwnerIdEmployerWorkItemIdImport.update({
    id: '/employer/$workItemId',
    path: '/employer/$workItemId',
    getParentRoute: () => ClubOwnerIdRoute
  } as any);

const ClubOwnerIdClubChatRoute = ClubOwnerIdClubChatImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => ClubOwnerIdClubRoute
} as any);

const ArtistIdWorkRequestWorkRequestIdRoute =
  ArtistIdWorkRequestWorkRequestIdImport.update({
    id: '/work-request/$workRequestId',
    path: '/work-request/$workRequestId',
    getParentRoute: () => ArtistIdRoute
  } as any);

const ArtistIdWorkInviteWorkInviteIdRoute =
  ArtistIdWorkInviteWorkInviteIdImport.update({
    id: '/work-invite/$workInviteId',
    path: '/work-invite/$workInviteId',
    getParentRoute: () => ArtistIdRoute
  } as any);

const ArtistIdProfileprofileRoute = ArtistIdProfileprofileImport.update({
  id: '/_profile',
  getParentRoute: () => ArtistIdProfileRoute
} as any);

const ArtistIdProfileInfoClubIdRoute = ArtistIdProfileInfoClubIdImport.update({
  id: '/profile-info/$clubId',
  path: '/profile-info/$clubId',
  getParentRoute: () => ArtistIdRoute
} as any);

const ArtistIdArtistSearchRoute = ArtistIdArtistSearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => ArtistIdArtistRoute
} as any);

const ArtistIdArtistChatRoute = ArtistIdArtistChatImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => ArtistIdArtistRoute
} as any);

const AuthAuthRegisterRegisterRouteRoute =
  AuthAuthRegisterRegisterRouteImport.update({
    id: '/auth/register_/register',
    path: '/auth/register/register',
    getParentRoute: () => AuthLazyRoute
  } as any).lazy(() =>
    import('./routes/_auth/auth/register_/register/route.lazy').then(
      (d) => d.Route
    )
  );

const AuthAuthRegisterConfirmationRouteRoute =
  AuthAuthRegisterConfirmationRouteImport.update({
    id: '/auth/register_/confirmation',
    path: '/auth/register/confirmation',
    getParentRoute: () => AuthLazyRoute
  } as any).lazy(() =>
    import('./routes/_auth/auth/register_/confirmation/route.lazy').then(
      (d) => d.Route
    )
  );

const AuthAuthForgotPasswordResetRouteRoute =
  AuthAuthForgotPasswordResetRouteImport.update({
    id: '/auth/forgot-password_/reset',
    path: '/auth/forgot-password/reset',
    getParentRoute: () => AuthLazyRoute
  } as any).lazy(() =>
    import('./routes/_auth/auth/forgot-password_/reset/route.lazy').then(
      (d) => d.Route
    )
  );

const AuthAuthForgotPasswordEmailRouteRoute =
  AuthAuthForgotPasswordEmailRouteImport.update({
    id: '/auth/forgot-password_/email',
    path: '/auth/forgot-password/email',
    getParentRoute: () => AuthLazyRoute
  } as any);

const AuthAuthForgotPasswordConfirmationRouteRoute =
  AuthAuthForgotPasswordConfirmationRouteImport.update({
    id: '/auth/forgot-password_/confirmation',
    path: '/auth/forgot-password/confirmation',
    getParentRoute: () => AuthLazyRoute
  } as any).lazy(() =>
    import('./routes/_auth/auth/forgot-password_/confirmation/route.lazy').then(
      (d) => d.Route
    )
  );

const ClubOwnerIdClubSearchIndexRoute = ClubOwnerIdClubSearchIndexImport.update(
  {
    id: '/search/',
    path: '/search/',
    getParentRoute: () => ClubOwnerIdClubRoute
  } as any
);

const ClubOwnerIdProfileprofilePortfolioRouteLazyRoute =
  ClubOwnerIdProfileprofilePortfolioRouteLazyImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => ClubOwnerIdProfileprofileRoute
  } as any).lazy(() =>
    import(
      './routes/clubOwner/$id/profile_/_profile/portfolio/route.lazy'
    ).then((d) => d.Route)
  );

const ClubOwnerIdProfileprofileNotificationsRouteLazyRoute =
  ClubOwnerIdProfileprofileNotificationsRouteLazyImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ClubOwnerIdProfileprofileRoute
  } as any).lazy(() =>
    import(
      './routes/clubOwner/$id/profile_/_profile/notifications/route.lazy'
    ).then((d) => d.Route)
  );

const ClubOwnerIdProfileprofileLoyaltyRouteLazyRoute =
  ClubOwnerIdProfileprofileLoyaltyRouteLazyImport.update({
    id: '/loyalty',
    path: '/loyalty',
    getParentRoute: () => ClubOwnerIdProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/clubOwner/$id/profile_/_profile/loyalty/route.lazy').then(
      (d) => d.Route
    )
  );

const ClubOwnerIdProfileprofileLanguageRouteLazyRoute =
  ClubOwnerIdProfileprofileLanguageRouteLazyImport.update({
    id: '/language',
    path: '/language',
    getParentRoute: () => ClubOwnerIdProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/clubOwner/$id/profile_/_profile/language/route.lazy').then(
      (d) => d.Route
    )
  );

const ClubOwnerIdProfileprofileInfoRouteLazyRoute =
  ClubOwnerIdProfileprofileInfoRouteLazyImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => ClubOwnerIdProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/clubOwner/$id/profile_/_profile/info/route.lazy').then(
      (d) => d.Route
    )
  );

const ClubOwnerIdProfileprofileEmployersRouteLazyRoute =
  ClubOwnerIdProfileprofileEmployersRouteLazyImport.update({
    id: '/employers',
    path: '/employers',
    getParentRoute: () => ClubOwnerIdProfileprofileRoute
  } as any).lazy(() =>
    import(
      './routes/clubOwner/$id/profile_/_profile/employers/route.lazy'
    ).then((d) => d.Route)
  );

const ClubOwnerIdProfileprofileAplicationsRouteLazyRoute =
  ClubOwnerIdProfileprofileAplicationsRouteLazyImport.update({
    id: '/aplications',
    path: '/aplications',
    getParentRoute: () => ClubOwnerIdProfileprofileRoute
  } as any).lazy(() =>
    import(
      './routes/clubOwner/$id/profile_/_profile/aplications/route.lazy'
    ).then((d) => d.Route)
  );

const ArtistIdProfileprofilePortfolioRouteLazyRoute =
  ArtistIdProfileprofilePortfolioRouteLazyImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => ArtistIdProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/artist/$id/profile_/_profile/portfolio/route.lazy').then(
      (d) => d.Route
    )
  );

const ArtistIdProfileprofileNotificationsRouteLazyRoute =
  ArtistIdProfileprofileNotificationsRouteLazyImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ArtistIdProfileprofileRoute
  } as any).lazy(() =>
    import(
      './routes/artist/$id/profile_/_profile/notifications/route.lazy'
    ).then((d) => d.Route)
  );

const ArtistIdProfileprofileLoyaltyRouteLazyRoute =
  ArtistIdProfileprofileLoyaltyRouteLazyImport.update({
    id: '/loyalty',
    path: '/loyalty',
    getParentRoute: () => ArtistIdProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/artist/$id/profile_/_profile/loyalty/route.lazy').then(
      (d) => d.Route
    )
  );

const ArtistIdProfileprofileLanguageRouteLazyRoute =
  ArtistIdProfileprofileLanguageRouteLazyImport.update({
    id: '/language',
    path: '/language',
    getParentRoute: () => ArtistIdProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/artist/$id/profile_/_profile/language/route.lazy').then(
      (d) => d.Route
    )
  );

const ArtistIdProfileprofileInfoRouteLazyRoute =
  ArtistIdProfileprofileInfoRouteLazyImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => ArtistIdProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/artist/$id/profile_/_profile/info/route.lazy').then(
      (d) => d.Route
    )
  );

const ArtistIdProfileprofileAplicationsRouteLazyRoute =
  ArtistIdProfileprofileAplicationsRouteLazyImport.update({
    id: '/aplications',
    path: '/aplications',
    getParentRoute: () => ArtistIdProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/artist/$id/profile_/_profile/aplications/route.lazy').then(
      (d) => d.Route
    )
  );

const ClubOwnerIdOnboardOnboardStepRoute =
  ClubOwnerIdOnboardOnboardStepImport.update({
    id: '/onboard/$step',
    path: '/onboard/$step',
    getParentRoute: () => ClubOwnerIdOnboardRoute
  } as any).lazy(() =>
    import('./routes/clubOwner/$id/_onboard/onboard.$step.lazy').then(
      (d) => d.Route
    )
  );

const ClubOwnerIdClubProfileprofileRoute =
  ClubOwnerIdClubProfileprofileImport.update({
    id: '/_profile',
    getParentRoute: () => ClubOwnerIdClubProfileRoute
  } as any).lazy(() =>
    import('./routes/clubOwner/$id/_club/profile_/_profile.lazy').then(
      (d) => d.Route
    )
  );

const ArtistIdOnboardOnboardStepRoute = ArtistIdOnboardOnboardStepImport.update(
  {
    id: '/onboard/$step',
    path: '/onboard/$step',
    getParentRoute: () => ArtistIdOnboardRoute
  } as any
).lazy(() =>
  import('./routes/artist/$id/_onboard/onboard.$step.lazy').then((d) => d.Route)
);

const ArtistIdArtistProfileprofileRoute =
  ArtistIdArtistProfileprofileImport.update({
    id: '/_profile',
    getParentRoute: () => ArtistIdArtistProfileRoute
  } as any).lazy(() =>
    import('./routes/artist/$id/_artist/profile_/_profile.lazy').then(
      (d) => d.Route
    )
  );

const AdminAdminChatConversationConversationIdRoute =
  AdminAdminChatConversationConversationIdImport.update({
    id: '/conversation/$conversationId',
    path: '/conversation/$conversationId',
    getParentRoute: () => AdminAdminChatRoute
  } as any).lazy(() =>
    import('./routes/admin/_admin/chat.conversation.$conversationId.lazy').then(
      (d) => d.Route
    )
  );

const ClubOwnerIdProfileprofileTermsRouteRoute =
  ClubOwnerIdProfileprofileTermsRouteImport.update({
    id: '/terms',
    path: '/terms',
    getParentRoute: () => ClubOwnerIdProfileprofileRoute
  } as any);

const ClubOwnerIdClubProfileprofileIndexRoute =
  ClubOwnerIdClubProfileprofileIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClubOwnerIdClubProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/clubOwner/$id/_club/profile_/_profile/index.lazy').then(
      (d) => d.Route
    )
  );

const ArtistIdArtistProfileprofileIndexRoute =
  ArtistIdArtistProfileprofileIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ArtistIdArtistProfileprofileRoute
  } as any).lazy(() =>
    import('./routes/artist/$id/_artist/profile_/_profile/index.lazy').then(
      (d) => d.Route
    )
  );

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/_auth': {
      id: '/_auth';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AuthLazyImport;
      parentRoute: typeof rootRoute;
    };
    '/_club': {
      id: '/_club';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof ClubLazyImport;
      parentRoute: typeof rootRoute;
    };
    '/privacy-policy': {
      id: '/privacy-policy';
      path: '/privacy-policy';
      fullPath: '/privacy-policy';
      preLoaderRoute: typeof PrivacyPolicyLazyImport;
      parentRoute: typeof rootRoute;
    };
    '/admin': {
      id: '/admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminImport;
      parentRoute: typeof rootRoute;
    };
    '/admin/_admin': {
      id: '/admin/_admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminAdminImport;
      parentRoute: typeof AdminRoute;
    };
    '/conversation/$conversationId': {
      id: '/conversation/$conversationId';
      path: '/conversation/$conversationId';
      fullPath: '/conversation/$conversationId';
      preLoaderRoute: typeof ConversationConversationIdImport;
      parentRoute: typeof rootRoute;
    };
    '/invite/$inviteId': {
      id: '/invite/$inviteId';
      path: '/invite/$inviteId';
      fullPath: '/invite/$inviteId';
      preLoaderRoute: typeof InviteInviteIdImport;
      parentRoute: typeof rootRoute;
    };
    '/invite/role': {
      id: '/invite/role';
      path: '/invite/role';
      fullPath: '/invite/role';
      preLoaderRoute: typeof InviteRoleLazyImport;
      parentRoute: typeof rootRoute;
    };
    '/_auth/auth/login': {
      id: '/_auth/auth/login';
      path: '/auth/login';
      fullPath: '/auth/login';
      preLoaderRoute: typeof AuthAuthLoginRouteImport;
      parentRoute: typeof AuthLazyImport;
    };
    '/artist/$id/current-work': {
      id: '/artist/$id/current-work';
      path: '/artist/$id/current-work';
      fullPath: '/artist/$id/current-work';
      preLoaderRoute: typeof ArtistIdCurrentWorkRouteImport;
      parentRoute: typeof rootRoute;
    };
    '/admin/_admin/artists': {
      id: '/admin/_admin/artists';
      path: '/artists';
      fullPath: '/admin/artists';
      preLoaderRoute: typeof AdminAdminArtistsImport;
      parentRoute: typeof AdminAdminImport;
    };
    '/admin/_admin/chat': {
      id: '/admin/_admin/chat';
      path: '/chat';
      fullPath: '/admin/chat';
      preLoaderRoute: typeof AdminAdminChatImport;
      parentRoute: typeof AdminAdminImport;
    };
    '/admin/_admin/clubs': {
      id: '/admin/_admin/clubs';
      path: '/clubs';
      fullPath: '/admin/clubs';
      preLoaderRoute: typeof AdminAdminClubsImport;
      parentRoute: typeof AdminAdminImport;
    };
    '/admin/_admin/global-events': {
      id: '/admin/_admin/global-events';
      path: '/global-events';
      fullPath: '/admin/global-events';
      preLoaderRoute: typeof AdminAdminGlobalEventsImport;
      parentRoute: typeof AdminAdminImport;
    };
    '/admin/_admin/kanban': {
      id: '/admin/_admin/kanban';
      path: '/kanban';
      fullPath: '/admin/kanban';
      preLoaderRoute: typeof AdminAdminKanbanImport;
      parentRoute: typeof AdminAdminImport;
    };
    '/admin/_admin/register-requests': {
      id: '/admin/_admin/register-requests';
      path: '/register-requests';
      fullPath: '/admin/register-requests';
      preLoaderRoute: typeof AdminAdminRegisterRequestsImport;
      parentRoute: typeof AdminAdminImport;
    };
    '/artist/$id': {
      id: '/artist/$id';
      path: '/artist/$id';
      fullPath: '/artist/$id';
      preLoaderRoute: typeof ArtistIdImport;
      parentRoute: typeof rootRoute;
    };
    '/artist/$id/_artist': {
      id: '/artist/$id/_artist';
      path: '/artist/$id';
      fullPath: '/artist/$id';
      preLoaderRoute: typeof ArtistIdArtistImport;
      parentRoute: typeof ArtistIdRoute;
    };
    '/artist/$id/_onboard': {
      id: '/artist/$id/_onboard';
      path: '';
      fullPath: '/artist/$id';
      preLoaderRoute: typeof ArtistIdOnboardImport;
      parentRoute: typeof ArtistIdImport;
    };
    '/clubOwner/$id': {
      id: '/clubOwner/$id';
      path: '/clubOwner/$id';
      fullPath: '/clubOwner/$id';
      preLoaderRoute: typeof ClubOwnerIdImport;
      parentRoute: typeof rootRoute;
    };
    '/clubOwner/$id/_club': {
      id: '/clubOwner/$id/_club';
      path: '/clubOwner/$id';
      fullPath: '/clubOwner/$id';
      preLoaderRoute: typeof ClubOwnerIdClubImport;
      parentRoute: typeof ClubOwnerIdRoute;
    };
    '/clubOwner/$id/_onboard': {
      id: '/clubOwner/$id/_onboard';
      path: '';
      fullPath: '/clubOwner/$id';
      preLoaderRoute: typeof ClubOwnerIdOnboardImport;
      parentRoute: typeof ClubOwnerIdImport;
    };
    '/_auth/auth/forgot-password_/confirmation': {
      id: '/_auth/auth/forgot-password_/confirmation';
      path: '/auth/forgot-password/confirmation';
      fullPath: '/auth/forgot-password/confirmation';
      preLoaderRoute: typeof AuthAuthForgotPasswordConfirmationRouteImport;
      parentRoute: typeof AuthLazyImport;
    };
    '/_auth/auth/forgot-password_/email': {
      id: '/_auth/auth/forgot-password_/email';
      path: '/auth/forgot-password/email';
      fullPath: '/auth/forgot-password/email';
      preLoaderRoute: typeof AuthAuthForgotPasswordEmailRouteImport;
      parentRoute: typeof AuthLazyImport;
    };
    '/_auth/auth/forgot-password_/reset': {
      id: '/_auth/auth/forgot-password_/reset';
      path: '/auth/forgot-password/reset';
      fullPath: '/auth/forgot-password/reset';
      preLoaderRoute: typeof AuthAuthForgotPasswordResetRouteImport;
      parentRoute: typeof AuthLazyImport;
    };
    '/_auth/auth/register_/confirmation': {
      id: '/_auth/auth/register_/confirmation';
      path: '/auth/register/confirmation';
      fullPath: '/auth/register/confirmation';
      preLoaderRoute: typeof AuthAuthRegisterConfirmationRouteImport;
      parentRoute: typeof AuthLazyImport;
    };
    '/_auth/auth/register_/register': {
      id: '/_auth/auth/register_/register';
      path: '/auth/register/register';
      fullPath: '/auth/register/register';
      preLoaderRoute: typeof AuthAuthRegisterRegisterRouteImport;
      parentRoute: typeof AuthLazyImport;
    };
    '/artist/$id/_artist/chat': {
      id: '/artist/$id/_artist/chat';
      path: '/chat';
      fullPath: '/artist/$id/chat';
      preLoaderRoute: typeof ArtistIdArtistChatImport;
      parentRoute: typeof ArtistIdArtistImport;
    };
    '/artist/$id/_artist/search': {
      id: '/artist/$id/_artist/search';
      path: '/search';
      fullPath: '/artist/$id/search';
      preLoaderRoute: typeof ArtistIdArtistSearchImport;
      parentRoute: typeof ArtistIdArtistImport;
    };
    '/artist/$id/profile-info/$clubId': {
      id: '/artist/$id/profile-info/$clubId';
      path: '/profile-info/$clubId';
      fullPath: '/artist/$id/profile-info/$clubId';
      preLoaderRoute: typeof ArtistIdProfileInfoClubIdImport;
      parentRoute: typeof ArtistIdImport;
    };
    '/artist/$id/profile_': {
      id: '/artist/$id/profile_';
      path: '/profile';
      fullPath: '/artist/$id/profile';
      preLoaderRoute: typeof ArtistIdProfileImport;
      parentRoute: typeof ArtistIdImport;
    };
    '/artist/$id/profile_/_profile': {
      id: '/artist/$id/profile_/_profile';
      path: '/profile';
      fullPath: '/artist/$id/profile';
      preLoaderRoute: typeof ArtistIdProfileprofileImport;
      parentRoute: typeof ArtistIdProfileRoute;
    };
    '/artist/$id/work-invite/$workInviteId': {
      id: '/artist/$id/work-invite/$workInviteId';
      path: '/work-invite/$workInviteId';
      fullPath: '/artist/$id/work-invite/$workInviteId';
      preLoaderRoute: typeof ArtistIdWorkInviteWorkInviteIdImport;
      parentRoute: typeof ArtistIdImport;
    };
    '/artist/$id/work-request/$workRequestId': {
      id: '/artist/$id/work-request/$workRequestId';
      path: '/work-request/$workRequestId';
      fullPath: '/artist/$id/work-request/$workRequestId';
      preLoaderRoute: typeof ArtistIdWorkRequestWorkRequestIdImport;
      parentRoute: typeof ArtistIdImport;
    };
    '/clubOwner/$id/_club/chat': {
      id: '/clubOwner/$id/_club/chat';
      path: '/chat';
      fullPath: '/clubOwner/$id/chat';
      preLoaderRoute: typeof ClubOwnerIdClubChatImport;
      parentRoute: typeof ClubOwnerIdClubImport;
    };
    '/clubOwner/$id/employer/$workItemId': {
      id: '/clubOwner/$id/employer/$workItemId';
      path: '/employer/$workItemId';
      fullPath: '/clubOwner/$id/employer/$workItemId';
      preLoaderRoute: typeof ClubOwnerIdEmployerWorkItemIdImport;
      parentRoute: typeof ClubOwnerIdImport;
    };
    '/clubOwner/$id/profile-info/$profileId': {
      id: '/clubOwner/$id/profile-info/$profileId';
      path: '/profile-info/$profileId';
      fullPath: '/clubOwner/$id/profile-info/$profileId';
      preLoaderRoute: typeof ClubOwnerIdProfileInfoProfileIdImport;
      parentRoute: typeof ClubOwnerIdImport;
    };
    '/clubOwner/$id/profile_': {
      id: '/clubOwner/$id/profile_';
      path: '/profile';
      fullPath: '/clubOwner/$id/profile';
      preLoaderRoute: typeof ClubOwnerIdProfileImport;
      parentRoute: typeof ClubOwnerIdImport;
    };
    '/clubOwner/$id/profile_/_profile': {
      id: '/clubOwner/$id/profile_/_profile';
      path: '/profile';
      fullPath: '/clubOwner/$id/profile';
      preLoaderRoute: typeof ClubOwnerIdProfileprofileImport;
      parentRoute: typeof ClubOwnerIdProfileRoute;
    };
    '/clubOwner/$id/work-invite/$workInviteId': {
      id: '/clubOwner/$id/work-invite/$workInviteId';
      path: '/work-invite/$workInviteId';
      fullPath: '/clubOwner/$id/work-invite/$workInviteId';
      preLoaderRoute: typeof ClubOwnerIdWorkInviteWorkInviteIdImport;
      parentRoute: typeof ClubOwnerIdImport;
    };
    '/clubOwner/$id/work-request/$workRequestId': {
      id: '/clubOwner/$id/work-request/$workRequestId';
      path: '/work-request/$workRequestId';
      fullPath: '/clubOwner/$id/work-request/$workRequestId';
      preLoaderRoute: typeof ClubOwnerIdWorkRequestWorkRequestIdImport;
      parentRoute: typeof ClubOwnerIdImport;
    };
    '/clubOwner/$id/profile_/_profile/terms': {
      id: '/clubOwner/$id/profile_/_profile/terms';
      path: '/terms';
      fullPath: '/clubOwner/$id/profile/terms';
      preLoaderRoute: typeof ClubOwnerIdProfileprofileTermsRouteImport;
      parentRoute: typeof ClubOwnerIdProfileprofileImport;
    };
    '/admin/_admin/chat/conversation/$conversationId': {
      id: '/admin/_admin/chat/conversation/$conversationId';
      path: '/conversation/$conversationId';
      fullPath: '/admin/chat/conversation/$conversationId';
      preLoaderRoute: typeof AdminAdminChatConversationConversationIdImport;
      parentRoute: typeof AdminAdminChatImport;
    };
    '/artist/$id/_artist/profile_': {
      id: '/artist/$id/_artist/profile_';
      path: '/profile';
      fullPath: '/artist/$id/profile';
      preLoaderRoute: typeof ArtistIdArtistProfileImport;
      parentRoute: typeof ArtistIdArtistImport;
    };
    '/artist/$id/_artist/profile_/_profile': {
      id: '/artist/$id/_artist/profile_/_profile';
      path: '/profile';
      fullPath: '/artist/$id/profile';
      preLoaderRoute: typeof ArtistIdArtistProfileprofileImport;
      parentRoute: typeof ArtistIdArtistProfileRoute;
    };
    '/artist/$id/_onboard/onboard/$step': {
      id: '/artist/$id/_onboard/onboard/$step';
      path: '/onboard/$step';
      fullPath: '/artist/$id/onboard/$step';
      preLoaderRoute: typeof ArtistIdOnboardOnboardStepImport;
      parentRoute: typeof ArtistIdOnboardImport;
    };
    '/clubOwner/$id/_club/profile_': {
      id: '/clubOwner/$id/_club/profile_';
      path: '/profile';
      fullPath: '/clubOwner/$id/profile';
      preLoaderRoute: typeof ClubOwnerIdClubProfileImport;
      parentRoute: typeof ClubOwnerIdClubImport;
    };
    '/clubOwner/$id/_club/profile_/_profile': {
      id: '/clubOwner/$id/_club/profile_/_profile';
      path: '/profile';
      fullPath: '/clubOwner/$id/profile';
      preLoaderRoute: typeof ClubOwnerIdClubProfileprofileImport;
      parentRoute: typeof ClubOwnerIdClubProfileRoute;
    };
    '/clubOwner/$id/_onboard/onboard/$step': {
      id: '/clubOwner/$id/_onboard/onboard/$step';
      path: '/onboard/$step';
      fullPath: '/clubOwner/$id/onboard/$step';
      preLoaderRoute: typeof ClubOwnerIdOnboardOnboardStepImport;
      parentRoute: typeof ClubOwnerIdOnboardImport;
    };
    '/artist/$id/profile_/_profile/aplications': {
      id: '/artist/$id/profile_/_profile/aplications';
      path: '/aplications';
      fullPath: '/artist/$id/profile/aplications';
      preLoaderRoute: typeof ArtistIdProfileprofileAplicationsRouteLazyImport;
      parentRoute: typeof ArtistIdProfileprofileImport;
    };
    '/artist/$id/profile_/_profile/info': {
      id: '/artist/$id/profile_/_profile/info';
      path: '/info';
      fullPath: '/artist/$id/profile/info';
      preLoaderRoute: typeof ArtistIdProfileprofileInfoRouteLazyImport;
      parentRoute: typeof ArtistIdProfileprofileImport;
    };
    '/artist/$id/profile_/_profile/language': {
      id: '/artist/$id/profile_/_profile/language';
      path: '/language';
      fullPath: '/artist/$id/profile/language';
      preLoaderRoute: typeof ArtistIdProfileprofileLanguageRouteLazyImport;
      parentRoute: typeof ArtistIdProfileprofileImport;
    };
    '/artist/$id/profile_/_profile/loyalty': {
      id: '/artist/$id/profile_/_profile/loyalty';
      path: '/loyalty';
      fullPath: '/artist/$id/profile/loyalty';
      preLoaderRoute: typeof ArtistIdProfileprofileLoyaltyRouteLazyImport;
      parentRoute: typeof ArtistIdProfileprofileImport;
    };
    '/artist/$id/profile_/_profile/notifications': {
      id: '/artist/$id/profile_/_profile/notifications';
      path: '/notifications';
      fullPath: '/artist/$id/profile/notifications';
      preLoaderRoute: typeof ArtistIdProfileprofileNotificationsRouteLazyImport;
      parentRoute: typeof ArtistIdProfileprofileImport;
    };
    '/artist/$id/profile_/_profile/portfolio': {
      id: '/artist/$id/profile_/_profile/portfolio';
      path: '/portfolio';
      fullPath: '/artist/$id/profile/portfolio';
      preLoaderRoute: typeof ArtistIdProfileprofilePortfolioRouteLazyImport;
      parentRoute: typeof ArtistIdProfileprofileImport;
    };
    '/clubOwner/$id/profile_/_profile/aplications': {
      id: '/clubOwner/$id/profile_/_profile/aplications';
      path: '/aplications';
      fullPath: '/clubOwner/$id/profile/aplications';
      preLoaderRoute: typeof ClubOwnerIdProfileprofileAplicationsRouteLazyImport;
      parentRoute: typeof ClubOwnerIdProfileprofileImport;
    };
    '/clubOwner/$id/profile_/_profile/employers': {
      id: '/clubOwner/$id/profile_/_profile/employers';
      path: '/employers';
      fullPath: '/clubOwner/$id/profile/employers';
      preLoaderRoute: typeof ClubOwnerIdProfileprofileEmployersRouteLazyImport;
      parentRoute: typeof ClubOwnerIdProfileprofileImport;
    };
    '/clubOwner/$id/profile_/_profile/info': {
      id: '/clubOwner/$id/profile_/_profile/info';
      path: '/info';
      fullPath: '/clubOwner/$id/profile/info';
      preLoaderRoute: typeof ClubOwnerIdProfileprofileInfoRouteLazyImport;
      parentRoute: typeof ClubOwnerIdProfileprofileImport;
    };
    '/clubOwner/$id/profile_/_profile/language': {
      id: '/clubOwner/$id/profile_/_profile/language';
      path: '/language';
      fullPath: '/clubOwner/$id/profile/language';
      preLoaderRoute: typeof ClubOwnerIdProfileprofileLanguageRouteLazyImport;
      parentRoute: typeof ClubOwnerIdProfileprofileImport;
    };
    '/clubOwner/$id/profile_/_profile/loyalty': {
      id: '/clubOwner/$id/profile_/_profile/loyalty';
      path: '/loyalty';
      fullPath: '/clubOwner/$id/profile/loyalty';
      preLoaderRoute: typeof ClubOwnerIdProfileprofileLoyaltyRouteLazyImport;
      parentRoute: typeof ClubOwnerIdProfileprofileImport;
    };
    '/clubOwner/$id/profile_/_profile/notifications': {
      id: '/clubOwner/$id/profile_/_profile/notifications';
      path: '/notifications';
      fullPath: '/clubOwner/$id/profile/notifications';
      preLoaderRoute: typeof ClubOwnerIdProfileprofileNotificationsRouteLazyImport;
      parentRoute: typeof ClubOwnerIdProfileprofileImport;
    };
    '/clubOwner/$id/profile_/_profile/portfolio': {
      id: '/clubOwner/$id/profile_/_profile/portfolio';
      path: '/portfolio';
      fullPath: '/clubOwner/$id/profile/portfolio';
      preLoaderRoute: typeof ClubOwnerIdProfileprofilePortfolioRouteLazyImport;
      parentRoute: typeof ClubOwnerIdProfileprofileImport;
    };
    '/clubOwner/$id/_club/search/': {
      id: '/clubOwner/$id/_club/search/';
      path: '/search';
      fullPath: '/clubOwner/$id/search';
      preLoaderRoute: typeof ClubOwnerIdClubSearchIndexImport;
      parentRoute: typeof ClubOwnerIdClubImport;
    };
    '/artist/$id/_artist/profile_/_profile/': {
      id: '/artist/$id/_artist/profile_/_profile/';
      path: '/';
      fullPath: '/artist/$id/profile/';
      preLoaderRoute: typeof ArtistIdArtistProfileprofileIndexImport;
      parentRoute: typeof ArtistIdArtistProfileprofileImport;
    };
    '/clubOwner/$id/_club/profile_/_profile/': {
      id: '/clubOwner/$id/_club/profile_/_profile/';
      path: '/';
      fullPath: '/clubOwner/$id/profile/';
      preLoaderRoute: typeof ClubOwnerIdClubProfileprofileIndexImport;
      parentRoute: typeof ClubOwnerIdClubProfileprofileImport;
    };
  }
}

// Create and export the route tree

interface AuthLazyRouteChildren {
  AuthAuthLoginRouteRoute: typeof AuthAuthLoginRouteRoute;
  AuthAuthForgotPasswordConfirmationRouteRoute: typeof AuthAuthForgotPasswordConfirmationRouteRoute;
  AuthAuthForgotPasswordEmailRouteRoute: typeof AuthAuthForgotPasswordEmailRouteRoute;
  AuthAuthForgotPasswordResetRouteRoute: typeof AuthAuthForgotPasswordResetRouteRoute;
  AuthAuthRegisterConfirmationRouteRoute: typeof AuthAuthRegisterConfirmationRouteRoute;
  AuthAuthRegisterRegisterRouteRoute: typeof AuthAuthRegisterRegisterRouteRoute;
}

const AuthLazyRouteChildren: AuthLazyRouteChildren = {
  AuthAuthLoginRouteRoute: AuthAuthLoginRouteRoute,
  AuthAuthForgotPasswordConfirmationRouteRoute:
    AuthAuthForgotPasswordConfirmationRouteRoute,
  AuthAuthForgotPasswordEmailRouteRoute: AuthAuthForgotPasswordEmailRouteRoute,
  AuthAuthForgotPasswordResetRouteRoute: AuthAuthForgotPasswordResetRouteRoute,
  AuthAuthRegisterConfirmationRouteRoute:
    AuthAuthRegisterConfirmationRouteRoute,
  AuthAuthRegisterRegisterRouteRoute: AuthAuthRegisterRegisterRouteRoute
};

const AuthLazyRouteWithChildren = AuthLazyRoute._addFileChildren(
  AuthLazyRouteChildren
);

interface AdminAdminChatRouteChildren {
  AdminAdminChatConversationConversationIdRoute: typeof AdminAdminChatConversationConversationIdRoute;
}

const AdminAdminChatRouteChildren: AdminAdminChatRouteChildren = {
  AdminAdminChatConversationConversationIdRoute:
    AdminAdminChatConversationConversationIdRoute
};

const AdminAdminChatRouteWithChildren = AdminAdminChatRoute._addFileChildren(
  AdminAdminChatRouteChildren
);

interface AdminAdminRouteChildren {
  AdminAdminArtistsRoute: typeof AdminAdminArtistsRoute;
  AdminAdminChatRoute: typeof AdminAdminChatRouteWithChildren;
  AdminAdminClubsRoute: typeof AdminAdminClubsRoute;
  AdminAdminGlobalEventsRoute: typeof AdminAdminGlobalEventsRoute;
  AdminAdminKanbanRoute: typeof AdminAdminKanbanRoute;
  AdminAdminRegisterRequestsRoute: typeof AdminAdminRegisterRequestsRoute;
}

const AdminAdminRouteChildren: AdminAdminRouteChildren = {
  AdminAdminArtistsRoute: AdminAdminArtistsRoute,
  AdminAdminChatRoute: AdminAdminChatRouteWithChildren,
  AdminAdminClubsRoute: AdminAdminClubsRoute,
  AdminAdminGlobalEventsRoute: AdminAdminGlobalEventsRoute,
  AdminAdminKanbanRoute: AdminAdminKanbanRoute,
  AdminAdminRegisterRequestsRoute: AdminAdminRegisterRequestsRoute
};

const AdminAdminRouteWithChildren = AdminAdminRoute._addFileChildren(
  AdminAdminRouteChildren
);

interface AdminRouteChildren {
  AdminAdminRoute: typeof AdminAdminRouteWithChildren;
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminRoute: AdminAdminRouteWithChildren
};

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren);

interface ArtistIdArtistProfileprofileRouteChildren {
  ArtistIdArtistProfileprofileIndexRoute: typeof ArtistIdArtistProfileprofileIndexRoute;
}

const ArtistIdArtistProfileprofileRouteChildren: ArtistIdArtistProfileprofileRouteChildren =
  {
    ArtistIdArtistProfileprofileIndexRoute:
      ArtistIdArtistProfileprofileIndexRoute
  };

const ArtistIdArtistProfileprofileRouteWithChildren =
  ArtistIdArtistProfileprofileRoute._addFileChildren(
    ArtistIdArtistProfileprofileRouteChildren
  );

interface ArtistIdArtistProfileRouteChildren {
  ArtistIdArtistProfileprofileRoute: typeof ArtistIdArtistProfileprofileRouteWithChildren;
}

const ArtistIdArtistProfileRouteChildren: ArtistIdArtistProfileRouteChildren = {
  ArtistIdArtistProfileprofileRoute:
    ArtistIdArtistProfileprofileRouteWithChildren
};

const ArtistIdArtistProfileRouteWithChildren =
  ArtistIdArtistProfileRoute._addFileChildren(
    ArtistIdArtistProfileRouteChildren
  );

interface ArtistIdArtistRouteChildren {
  ArtistIdArtistChatRoute: typeof ArtistIdArtistChatRoute;
  ArtistIdArtistSearchRoute: typeof ArtistIdArtistSearchRoute;
  ArtistIdArtistProfileRoute: typeof ArtistIdArtistProfileRouteWithChildren;
}

const ArtistIdArtistRouteChildren: ArtistIdArtistRouteChildren = {
  ArtistIdArtistChatRoute: ArtistIdArtistChatRoute,
  ArtistIdArtistSearchRoute: ArtistIdArtistSearchRoute,
  ArtistIdArtistProfileRoute: ArtistIdArtistProfileRouteWithChildren
};

const ArtistIdArtistRouteWithChildren = ArtistIdArtistRoute._addFileChildren(
  ArtistIdArtistRouteChildren
);

interface ArtistIdOnboardRouteChildren {
  ArtistIdOnboardOnboardStepRoute: typeof ArtistIdOnboardOnboardStepRoute;
}

const ArtistIdOnboardRouteChildren: ArtistIdOnboardRouteChildren = {
  ArtistIdOnboardOnboardStepRoute: ArtistIdOnboardOnboardStepRoute
};

const ArtistIdOnboardRouteWithChildren = ArtistIdOnboardRoute._addFileChildren(
  ArtistIdOnboardRouteChildren
);

interface ArtistIdProfileprofileRouteChildren {
  ArtistIdProfileprofileAplicationsRouteLazyRoute: typeof ArtistIdProfileprofileAplicationsRouteLazyRoute;
  ArtistIdProfileprofileInfoRouteLazyRoute: typeof ArtistIdProfileprofileInfoRouteLazyRoute;
  ArtistIdProfileprofileLanguageRouteLazyRoute: typeof ArtistIdProfileprofileLanguageRouteLazyRoute;
  ArtistIdProfileprofileLoyaltyRouteLazyRoute: typeof ArtistIdProfileprofileLoyaltyRouteLazyRoute;
  ArtistIdProfileprofileNotificationsRouteLazyRoute: typeof ArtistIdProfileprofileNotificationsRouteLazyRoute;
  ArtistIdProfileprofilePortfolioRouteLazyRoute: typeof ArtistIdProfileprofilePortfolioRouteLazyRoute;
}

const ArtistIdProfileprofileRouteChildren: ArtistIdProfileprofileRouteChildren =
  {
    ArtistIdProfileprofileAplicationsRouteLazyRoute:
      ArtistIdProfileprofileAplicationsRouteLazyRoute,
    ArtistIdProfileprofileInfoRouteLazyRoute:
      ArtistIdProfileprofileInfoRouteLazyRoute,
    ArtistIdProfileprofileLanguageRouteLazyRoute:
      ArtistIdProfileprofileLanguageRouteLazyRoute,
    ArtistIdProfileprofileLoyaltyRouteLazyRoute:
      ArtistIdProfileprofileLoyaltyRouteLazyRoute,
    ArtistIdProfileprofileNotificationsRouteLazyRoute:
      ArtistIdProfileprofileNotificationsRouteLazyRoute,
    ArtistIdProfileprofilePortfolioRouteLazyRoute:
      ArtistIdProfileprofilePortfolioRouteLazyRoute
  };

const ArtistIdProfileprofileRouteWithChildren =
  ArtistIdProfileprofileRoute._addFileChildren(
    ArtistIdProfileprofileRouteChildren
  );

interface ArtistIdProfileRouteChildren {
  ArtistIdProfileprofileRoute: typeof ArtistIdProfileprofileRouteWithChildren;
}

const ArtistIdProfileRouteChildren: ArtistIdProfileRouteChildren = {
  ArtistIdProfileprofileRoute: ArtistIdProfileprofileRouteWithChildren
};

const ArtistIdProfileRouteWithChildren = ArtistIdProfileRoute._addFileChildren(
  ArtistIdProfileRouteChildren
);

interface ArtistIdRouteChildren {
  ArtistIdArtistRoute: typeof ArtistIdArtistRouteWithChildren;
  ArtistIdOnboardRoute: typeof ArtistIdOnboardRouteWithChildren;
  ArtistIdProfileInfoClubIdRoute: typeof ArtistIdProfileInfoClubIdRoute;
  ArtistIdProfileRoute: typeof ArtistIdProfileRouteWithChildren;
  ArtistIdWorkInviteWorkInviteIdRoute: typeof ArtistIdWorkInviteWorkInviteIdRoute;
  ArtistIdWorkRequestWorkRequestIdRoute: typeof ArtistIdWorkRequestWorkRequestIdRoute;
}

const ArtistIdRouteChildren: ArtistIdRouteChildren = {
  ArtistIdArtistRoute: ArtistIdArtistRouteWithChildren,
  ArtistIdOnboardRoute: ArtistIdOnboardRouteWithChildren,
  ArtistIdProfileInfoClubIdRoute: ArtistIdProfileInfoClubIdRoute,
  ArtistIdProfileRoute: ArtistIdProfileRouteWithChildren,
  ArtistIdWorkInviteWorkInviteIdRoute: ArtistIdWorkInviteWorkInviteIdRoute,
  ArtistIdWorkRequestWorkRequestIdRoute: ArtistIdWorkRequestWorkRequestIdRoute
};

const ArtistIdRouteWithChildren = ArtistIdRoute._addFileChildren(
  ArtistIdRouteChildren
);

interface ClubOwnerIdClubProfileprofileRouteChildren {
  ClubOwnerIdClubProfileprofileIndexRoute: typeof ClubOwnerIdClubProfileprofileIndexRoute;
}

const ClubOwnerIdClubProfileprofileRouteChildren: ClubOwnerIdClubProfileprofileRouteChildren =
  {
    ClubOwnerIdClubProfileprofileIndexRoute:
      ClubOwnerIdClubProfileprofileIndexRoute
  };

const ClubOwnerIdClubProfileprofileRouteWithChildren =
  ClubOwnerIdClubProfileprofileRoute._addFileChildren(
    ClubOwnerIdClubProfileprofileRouteChildren
  );

interface ClubOwnerIdClubProfileRouteChildren {
  ClubOwnerIdClubProfileprofileRoute: typeof ClubOwnerIdClubProfileprofileRouteWithChildren;
}

const ClubOwnerIdClubProfileRouteChildren: ClubOwnerIdClubProfileRouteChildren =
  {
    ClubOwnerIdClubProfileprofileRoute:
      ClubOwnerIdClubProfileprofileRouteWithChildren
  };

const ClubOwnerIdClubProfileRouteWithChildren =
  ClubOwnerIdClubProfileRoute._addFileChildren(
    ClubOwnerIdClubProfileRouteChildren
  );

interface ClubOwnerIdClubRouteChildren {
  ClubOwnerIdClubChatRoute: typeof ClubOwnerIdClubChatRoute;
  ClubOwnerIdClubProfileRoute: typeof ClubOwnerIdClubProfileRouteWithChildren;
  ClubOwnerIdClubSearchIndexRoute: typeof ClubOwnerIdClubSearchIndexRoute;
}

const ClubOwnerIdClubRouteChildren: ClubOwnerIdClubRouteChildren = {
  ClubOwnerIdClubChatRoute: ClubOwnerIdClubChatRoute,
  ClubOwnerIdClubProfileRoute: ClubOwnerIdClubProfileRouteWithChildren,
  ClubOwnerIdClubSearchIndexRoute: ClubOwnerIdClubSearchIndexRoute
};

const ClubOwnerIdClubRouteWithChildren = ClubOwnerIdClubRoute._addFileChildren(
  ClubOwnerIdClubRouteChildren
);

interface ClubOwnerIdOnboardRouteChildren {
  ClubOwnerIdOnboardOnboardStepRoute: typeof ClubOwnerIdOnboardOnboardStepRoute;
}

const ClubOwnerIdOnboardRouteChildren: ClubOwnerIdOnboardRouteChildren = {
  ClubOwnerIdOnboardOnboardStepRoute: ClubOwnerIdOnboardOnboardStepRoute
};

const ClubOwnerIdOnboardRouteWithChildren =
  ClubOwnerIdOnboardRoute._addFileChildren(ClubOwnerIdOnboardRouteChildren);

interface ClubOwnerIdProfileprofileRouteChildren {
  ClubOwnerIdProfileprofileTermsRouteRoute: typeof ClubOwnerIdProfileprofileTermsRouteRoute;
  ClubOwnerIdProfileprofileAplicationsRouteLazyRoute: typeof ClubOwnerIdProfileprofileAplicationsRouteLazyRoute;
  ClubOwnerIdProfileprofileEmployersRouteLazyRoute: typeof ClubOwnerIdProfileprofileEmployersRouteLazyRoute;
  ClubOwnerIdProfileprofileInfoRouteLazyRoute: typeof ClubOwnerIdProfileprofileInfoRouteLazyRoute;
  ClubOwnerIdProfileprofileLanguageRouteLazyRoute: typeof ClubOwnerIdProfileprofileLanguageRouteLazyRoute;
  ClubOwnerIdProfileprofileLoyaltyRouteLazyRoute: typeof ClubOwnerIdProfileprofileLoyaltyRouteLazyRoute;
  ClubOwnerIdProfileprofileNotificationsRouteLazyRoute: typeof ClubOwnerIdProfileprofileNotificationsRouteLazyRoute;
  ClubOwnerIdProfileprofilePortfolioRouteLazyRoute: typeof ClubOwnerIdProfileprofilePortfolioRouteLazyRoute;
}

const ClubOwnerIdProfileprofileRouteChildren: ClubOwnerIdProfileprofileRouteChildren =
  {
    ClubOwnerIdProfileprofileTermsRouteRoute:
      ClubOwnerIdProfileprofileTermsRouteRoute,
    ClubOwnerIdProfileprofileAplicationsRouteLazyRoute:
      ClubOwnerIdProfileprofileAplicationsRouteLazyRoute,
    ClubOwnerIdProfileprofileEmployersRouteLazyRoute:
      ClubOwnerIdProfileprofileEmployersRouteLazyRoute,
    ClubOwnerIdProfileprofileInfoRouteLazyRoute:
      ClubOwnerIdProfileprofileInfoRouteLazyRoute,
    ClubOwnerIdProfileprofileLanguageRouteLazyRoute:
      ClubOwnerIdProfileprofileLanguageRouteLazyRoute,
    ClubOwnerIdProfileprofileLoyaltyRouteLazyRoute:
      ClubOwnerIdProfileprofileLoyaltyRouteLazyRoute,
    ClubOwnerIdProfileprofileNotificationsRouteLazyRoute:
      ClubOwnerIdProfileprofileNotificationsRouteLazyRoute,
    ClubOwnerIdProfileprofilePortfolioRouteLazyRoute:
      ClubOwnerIdProfileprofilePortfolioRouteLazyRoute
  };

const ClubOwnerIdProfileprofileRouteWithChildren =
  ClubOwnerIdProfileprofileRoute._addFileChildren(
    ClubOwnerIdProfileprofileRouteChildren
  );

interface ClubOwnerIdProfileRouteChildren {
  ClubOwnerIdProfileprofileRoute: typeof ClubOwnerIdProfileprofileRouteWithChildren;
}

const ClubOwnerIdProfileRouteChildren: ClubOwnerIdProfileRouteChildren = {
  ClubOwnerIdProfileprofileRoute: ClubOwnerIdProfileprofileRouteWithChildren
};

const ClubOwnerIdProfileRouteWithChildren =
  ClubOwnerIdProfileRoute._addFileChildren(ClubOwnerIdProfileRouteChildren);

interface ClubOwnerIdRouteChildren {
  ClubOwnerIdClubRoute: typeof ClubOwnerIdClubRouteWithChildren;
  ClubOwnerIdOnboardRoute: typeof ClubOwnerIdOnboardRouteWithChildren;
  ClubOwnerIdEmployerWorkItemIdRoute: typeof ClubOwnerIdEmployerWorkItemIdRoute;
  ClubOwnerIdProfileInfoProfileIdRoute: typeof ClubOwnerIdProfileInfoProfileIdRoute;
  ClubOwnerIdProfileRoute: typeof ClubOwnerIdProfileRouteWithChildren;
  ClubOwnerIdWorkInviteWorkInviteIdRoute: typeof ClubOwnerIdWorkInviteWorkInviteIdRoute;
  ClubOwnerIdWorkRequestWorkRequestIdRoute: typeof ClubOwnerIdWorkRequestWorkRequestIdRoute;
}

const ClubOwnerIdRouteChildren: ClubOwnerIdRouteChildren = {
  ClubOwnerIdClubRoute: ClubOwnerIdClubRouteWithChildren,
  ClubOwnerIdOnboardRoute: ClubOwnerIdOnboardRouteWithChildren,
  ClubOwnerIdEmployerWorkItemIdRoute: ClubOwnerIdEmployerWorkItemIdRoute,
  ClubOwnerIdProfileInfoProfileIdRoute: ClubOwnerIdProfileInfoProfileIdRoute,
  ClubOwnerIdProfileRoute: ClubOwnerIdProfileRouteWithChildren,
  ClubOwnerIdWorkInviteWorkInviteIdRoute:
    ClubOwnerIdWorkInviteWorkInviteIdRoute,
  ClubOwnerIdWorkRequestWorkRequestIdRoute:
    ClubOwnerIdWorkRequestWorkRequestIdRoute
};

const ClubOwnerIdRouteWithChildren = ClubOwnerIdRoute._addFileChildren(
  ClubOwnerIdRouteChildren
);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '': typeof ClubLazyRoute;
  '/privacy-policy': typeof PrivacyPolicyLazyRoute;
  '/admin': typeof AdminAdminRouteWithChildren;
  '/conversation/$conversationId': typeof ConversationConversationIdRoute;
  '/invite/$inviteId': typeof InviteInviteIdRoute;
  '/invite/role': typeof InviteRoleLazyRoute;
  '/auth/login': typeof AuthAuthLoginRouteRoute;
  '/artist/$id/current-work': typeof ArtistIdCurrentWorkRouteRoute;
  '/admin/artists': typeof AdminAdminArtistsRoute;
  '/admin/chat': typeof AdminAdminChatRouteWithChildren;
  '/admin/clubs': typeof AdminAdminClubsRoute;
  '/admin/global-events': typeof AdminAdminGlobalEventsRoute;
  '/admin/kanban': typeof AdminAdminKanbanRoute;
  '/admin/register-requests': typeof AdminAdminRegisterRequestsRoute;
  '/artist/$id': typeof ArtistIdOnboardRouteWithChildren;
  '/clubOwner/$id': typeof ClubOwnerIdOnboardRouteWithChildren;
  '/auth/forgot-password/confirmation': typeof AuthAuthForgotPasswordConfirmationRouteRoute;
  '/auth/forgot-password/email': typeof AuthAuthForgotPasswordEmailRouteRoute;
  '/auth/forgot-password/reset': typeof AuthAuthForgotPasswordResetRouteRoute;
  '/auth/register/confirmation': typeof AuthAuthRegisterConfirmationRouteRoute;
  '/auth/register/register': typeof AuthAuthRegisterRegisterRouteRoute;
  '/artist/$id/chat': typeof ArtistIdArtistChatRoute;
  '/artist/$id/search': typeof ArtistIdArtistSearchRoute;
  '/artist/$id/profile-info/$clubId': typeof ArtistIdProfileInfoClubIdRoute;
  '/artist/$id/profile': typeof ArtistIdArtistProfileprofileRouteWithChildren;
  '/artist/$id/work-invite/$workInviteId': typeof ArtistIdWorkInviteWorkInviteIdRoute;
  '/artist/$id/work-request/$workRequestId': typeof ArtistIdWorkRequestWorkRequestIdRoute;
  '/clubOwner/$id/chat': typeof ClubOwnerIdClubChatRoute;
  '/clubOwner/$id/employer/$workItemId': typeof ClubOwnerIdEmployerWorkItemIdRoute;
  '/clubOwner/$id/profile-info/$profileId': typeof ClubOwnerIdProfileInfoProfileIdRoute;
  '/clubOwner/$id/profile': typeof ClubOwnerIdClubProfileprofileRouteWithChildren;
  '/clubOwner/$id/work-invite/$workInviteId': typeof ClubOwnerIdWorkInviteWorkInviteIdRoute;
  '/clubOwner/$id/work-request/$workRequestId': typeof ClubOwnerIdWorkRequestWorkRequestIdRoute;
  '/clubOwner/$id/profile/terms': typeof ClubOwnerIdProfileprofileTermsRouteRoute;
  '/admin/chat/conversation/$conversationId': typeof AdminAdminChatConversationConversationIdRoute;
  '/artist/$id/onboard/$step': typeof ArtistIdOnboardOnboardStepRoute;
  '/clubOwner/$id/onboard/$step': typeof ClubOwnerIdOnboardOnboardStepRoute;
  '/artist/$id/profile/aplications': typeof ArtistIdProfileprofileAplicationsRouteLazyRoute;
  '/artist/$id/profile/info': typeof ArtistIdProfileprofileInfoRouteLazyRoute;
  '/artist/$id/profile/language': typeof ArtistIdProfileprofileLanguageRouteLazyRoute;
  '/artist/$id/profile/loyalty': typeof ArtistIdProfileprofileLoyaltyRouteLazyRoute;
  '/artist/$id/profile/notifications': typeof ArtistIdProfileprofileNotificationsRouteLazyRoute;
  '/artist/$id/profile/portfolio': typeof ArtistIdProfileprofilePortfolioRouteLazyRoute;
  '/clubOwner/$id/profile/aplications': typeof ClubOwnerIdProfileprofileAplicationsRouteLazyRoute;
  '/clubOwner/$id/profile/employers': typeof ClubOwnerIdProfileprofileEmployersRouteLazyRoute;
  '/clubOwner/$id/profile/info': typeof ClubOwnerIdProfileprofileInfoRouteLazyRoute;
  '/clubOwner/$id/profile/language': typeof ClubOwnerIdProfileprofileLanguageRouteLazyRoute;
  '/clubOwner/$id/profile/loyalty': typeof ClubOwnerIdProfileprofileLoyaltyRouteLazyRoute;
  '/clubOwner/$id/profile/notifications': typeof ClubOwnerIdProfileprofileNotificationsRouteLazyRoute;
  '/clubOwner/$id/profile/portfolio': typeof ClubOwnerIdProfileprofilePortfolioRouteLazyRoute;
  '/clubOwner/$id/search': typeof ClubOwnerIdClubSearchIndexRoute;
  '/artist/$id/profile/': typeof ArtistIdArtistProfileprofileIndexRoute;
  '/clubOwner/$id/profile/': typeof ClubOwnerIdClubProfileprofileIndexRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '': typeof ClubLazyRoute;
  '/privacy-policy': typeof PrivacyPolicyLazyRoute;
  '/admin': typeof AdminAdminRouteWithChildren;
  '/conversation/$conversationId': typeof ConversationConversationIdRoute;
  '/invite/$inviteId': typeof InviteInviteIdRoute;
  '/invite/role': typeof InviteRoleLazyRoute;
  '/auth/login': typeof AuthAuthLoginRouteRoute;
  '/artist/$id/current-work': typeof ArtistIdCurrentWorkRouteRoute;
  '/admin/artists': typeof AdminAdminArtistsRoute;
  '/admin/chat': typeof AdminAdminChatRouteWithChildren;
  '/admin/clubs': typeof AdminAdminClubsRoute;
  '/admin/global-events': typeof AdminAdminGlobalEventsRoute;
  '/admin/kanban': typeof AdminAdminKanbanRoute;
  '/admin/register-requests': typeof AdminAdminRegisterRequestsRoute;
  '/artist/$id': typeof ArtistIdOnboardRouteWithChildren;
  '/clubOwner/$id': typeof ClubOwnerIdOnboardRouteWithChildren;
  '/auth/forgot-password/confirmation': typeof AuthAuthForgotPasswordConfirmationRouteRoute;
  '/auth/forgot-password/email': typeof AuthAuthForgotPasswordEmailRouteRoute;
  '/auth/forgot-password/reset': typeof AuthAuthForgotPasswordResetRouteRoute;
  '/auth/register/confirmation': typeof AuthAuthRegisterConfirmationRouteRoute;
  '/auth/register/register': typeof AuthAuthRegisterRegisterRouteRoute;
  '/artist/$id/chat': typeof ArtistIdArtistChatRoute;
  '/artist/$id/search': typeof ArtistIdArtistSearchRoute;
  '/artist/$id/profile-info/$clubId': typeof ArtistIdProfileInfoClubIdRoute;
  '/artist/$id/profile': typeof ArtistIdArtistProfileprofileIndexRoute;
  '/artist/$id/work-invite/$workInviteId': typeof ArtistIdWorkInviteWorkInviteIdRoute;
  '/artist/$id/work-request/$workRequestId': typeof ArtistIdWorkRequestWorkRequestIdRoute;
  '/clubOwner/$id/chat': typeof ClubOwnerIdClubChatRoute;
  '/clubOwner/$id/employer/$workItemId': typeof ClubOwnerIdEmployerWorkItemIdRoute;
  '/clubOwner/$id/profile-info/$profileId': typeof ClubOwnerIdProfileInfoProfileIdRoute;
  '/clubOwner/$id/profile': typeof ClubOwnerIdClubProfileprofileIndexRoute;
  '/clubOwner/$id/work-invite/$workInviteId': typeof ClubOwnerIdWorkInviteWorkInviteIdRoute;
  '/clubOwner/$id/work-request/$workRequestId': typeof ClubOwnerIdWorkRequestWorkRequestIdRoute;
  '/clubOwner/$id/profile/terms': typeof ClubOwnerIdProfileprofileTermsRouteRoute;
  '/admin/chat/conversation/$conversationId': typeof AdminAdminChatConversationConversationIdRoute;
  '/artist/$id/onboard/$step': typeof ArtistIdOnboardOnboardStepRoute;
  '/clubOwner/$id/onboard/$step': typeof ClubOwnerIdOnboardOnboardStepRoute;
  '/artist/$id/profile/aplications': typeof ArtistIdProfileprofileAplicationsRouteLazyRoute;
  '/artist/$id/profile/info': typeof ArtistIdProfileprofileInfoRouteLazyRoute;
  '/artist/$id/profile/language': typeof ArtistIdProfileprofileLanguageRouteLazyRoute;
  '/artist/$id/profile/loyalty': typeof ArtistIdProfileprofileLoyaltyRouteLazyRoute;
  '/artist/$id/profile/notifications': typeof ArtistIdProfileprofileNotificationsRouteLazyRoute;
  '/artist/$id/profile/portfolio': typeof ArtistIdProfileprofilePortfolioRouteLazyRoute;
  '/clubOwner/$id/profile/aplications': typeof ClubOwnerIdProfileprofileAplicationsRouteLazyRoute;
  '/clubOwner/$id/profile/employers': typeof ClubOwnerIdProfileprofileEmployersRouteLazyRoute;
  '/clubOwner/$id/profile/info': typeof ClubOwnerIdProfileprofileInfoRouteLazyRoute;
  '/clubOwner/$id/profile/language': typeof ClubOwnerIdProfileprofileLanguageRouteLazyRoute;
  '/clubOwner/$id/profile/loyalty': typeof ClubOwnerIdProfileprofileLoyaltyRouteLazyRoute;
  '/clubOwner/$id/profile/notifications': typeof ClubOwnerIdProfileprofileNotificationsRouteLazyRoute;
  '/clubOwner/$id/profile/portfolio': typeof ClubOwnerIdProfileprofilePortfolioRouteLazyRoute;
  '/clubOwner/$id/search': typeof ClubOwnerIdClubSearchIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/_auth': typeof AuthLazyRouteWithChildren;
  '/_club': typeof ClubLazyRoute;
  '/privacy-policy': typeof PrivacyPolicyLazyRoute;
  '/admin': typeof AdminRouteWithChildren;
  '/admin/_admin': typeof AdminAdminRouteWithChildren;
  '/conversation/$conversationId': typeof ConversationConversationIdRoute;
  '/invite/$inviteId': typeof InviteInviteIdRoute;
  '/invite/role': typeof InviteRoleLazyRoute;
  '/_auth/auth/login': typeof AuthAuthLoginRouteRoute;
  '/artist/$id/current-work': typeof ArtistIdCurrentWorkRouteRoute;
  '/admin/_admin/artists': typeof AdminAdminArtistsRoute;
  '/admin/_admin/chat': typeof AdminAdminChatRouteWithChildren;
  '/admin/_admin/clubs': typeof AdminAdminClubsRoute;
  '/admin/_admin/global-events': typeof AdminAdminGlobalEventsRoute;
  '/admin/_admin/kanban': typeof AdminAdminKanbanRoute;
  '/admin/_admin/register-requests': typeof AdminAdminRegisterRequestsRoute;
  '/artist/$id': typeof ArtistIdRouteWithChildren;
  '/artist/$id/_artist': typeof ArtistIdArtistRouteWithChildren;
  '/artist/$id/_onboard': typeof ArtistIdOnboardRouteWithChildren;
  '/clubOwner/$id': typeof ClubOwnerIdRouteWithChildren;
  '/clubOwner/$id/_club': typeof ClubOwnerIdClubRouteWithChildren;
  '/clubOwner/$id/_onboard': typeof ClubOwnerIdOnboardRouteWithChildren;
  '/_auth/auth/forgot-password_/confirmation': typeof AuthAuthForgotPasswordConfirmationRouteRoute;
  '/_auth/auth/forgot-password_/email': typeof AuthAuthForgotPasswordEmailRouteRoute;
  '/_auth/auth/forgot-password_/reset': typeof AuthAuthForgotPasswordResetRouteRoute;
  '/_auth/auth/register_/confirmation': typeof AuthAuthRegisterConfirmationRouteRoute;
  '/_auth/auth/register_/register': typeof AuthAuthRegisterRegisterRouteRoute;
  '/artist/$id/_artist/chat': typeof ArtistIdArtistChatRoute;
  '/artist/$id/_artist/search': typeof ArtistIdArtistSearchRoute;
  '/artist/$id/profile-info/$clubId': typeof ArtistIdProfileInfoClubIdRoute;
  '/artist/$id/profile_': typeof ArtistIdProfileRouteWithChildren;
  '/artist/$id/profile_/_profile': typeof ArtistIdProfileprofileRouteWithChildren;
  '/artist/$id/work-invite/$workInviteId': typeof ArtistIdWorkInviteWorkInviteIdRoute;
  '/artist/$id/work-request/$workRequestId': typeof ArtistIdWorkRequestWorkRequestIdRoute;
  '/clubOwner/$id/_club/chat': typeof ClubOwnerIdClubChatRoute;
  '/clubOwner/$id/employer/$workItemId': typeof ClubOwnerIdEmployerWorkItemIdRoute;
  '/clubOwner/$id/profile-info/$profileId': typeof ClubOwnerIdProfileInfoProfileIdRoute;
  '/clubOwner/$id/profile_': typeof ClubOwnerIdProfileRouteWithChildren;
  '/clubOwner/$id/profile_/_profile': typeof ClubOwnerIdProfileprofileRouteWithChildren;
  '/clubOwner/$id/work-invite/$workInviteId': typeof ClubOwnerIdWorkInviteWorkInviteIdRoute;
  '/clubOwner/$id/work-request/$workRequestId': typeof ClubOwnerIdWorkRequestWorkRequestIdRoute;
  '/clubOwner/$id/profile_/_profile/terms': typeof ClubOwnerIdProfileprofileTermsRouteRoute;
  '/admin/_admin/chat/conversation/$conversationId': typeof AdminAdminChatConversationConversationIdRoute;
  '/artist/$id/_artist/profile_': typeof ArtistIdArtistProfileRouteWithChildren;
  '/artist/$id/_artist/profile_/_profile': typeof ArtistIdArtistProfileprofileRouteWithChildren;
  '/artist/$id/_onboard/onboard/$step': typeof ArtistIdOnboardOnboardStepRoute;
  '/clubOwner/$id/_club/profile_': typeof ClubOwnerIdClubProfileRouteWithChildren;
  '/clubOwner/$id/_club/profile_/_profile': typeof ClubOwnerIdClubProfileprofileRouteWithChildren;
  '/clubOwner/$id/_onboard/onboard/$step': typeof ClubOwnerIdOnboardOnboardStepRoute;
  '/artist/$id/profile_/_profile/aplications': typeof ArtistIdProfileprofileAplicationsRouteLazyRoute;
  '/artist/$id/profile_/_profile/info': typeof ArtistIdProfileprofileInfoRouteLazyRoute;
  '/artist/$id/profile_/_profile/language': typeof ArtistIdProfileprofileLanguageRouteLazyRoute;
  '/artist/$id/profile_/_profile/loyalty': typeof ArtistIdProfileprofileLoyaltyRouteLazyRoute;
  '/artist/$id/profile_/_profile/notifications': typeof ArtistIdProfileprofileNotificationsRouteLazyRoute;
  '/artist/$id/profile_/_profile/portfolio': typeof ArtistIdProfileprofilePortfolioRouteLazyRoute;
  '/clubOwner/$id/profile_/_profile/aplications': typeof ClubOwnerIdProfileprofileAplicationsRouteLazyRoute;
  '/clubOwner/$id/profile_/_profile/employers': typeof ClubOwnerIdProfileprofileEmployersRouteLazyRoute;
  '/clubOwner/$id/profile_/_profile/info': typeof ClubOwnerIdProfileprofileInfoRouteLazyRoute;
  '/clubOwner/$id/profile_/_profile/language': typeof ClubOwnerIdProfileprofileLanguageRouteLazyRoute;
  '/clubOwner/$id/profile_/_profile/loyalty': typeof ClubOwnerIdProfileprofileLoyaltyRouteLazyRoute;
  '/clubOwner/$id/profile_/_profile/notifications': typeof ClubOwnerIdProfileprofileNotificationsRouteLazyRoute;
  '/clubOwner/$id/profile_/_profile/portfolio': typeof ClubOwnerIdProfileprofilePortfolioRouteLazyRoute;
  '/clubOwner/$id/_club/search/': typeof ClubOwnerIdClubSearchIndexRoute;
  '/artist/$id/_artist/profile_/_profile/': typeof ArtistIdArtistProfileprofileIndexRoute;
  '/clubOwner/$id/_club/profile_/_profile/': typeof ClubOwnerIdClubProfileprofileIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | ''
    | '/privacy-policy'
    | '/admin'
    | '/conversation/$conversationId'
    | '/invite/$inviteId'
    | '/invite/role'
    | '/auth/login'
    | '/artist/$id/current-work'
    | '/admin/artists'
    | '/admin/chat'
    | '/admin/clubs'
    | '/admin/global-events'
    | '/admin/kanban'
    | '/admin/register-requests'
    | '/artist/$id'
    | '/clubOwner/$id'
    | '/auth/forgot-password/confirmation'
    | '/auth/forgot-password/email'
    | '/auth/forgot-password/reset'
    | '/auth/register/confirmation'
    | '/auth/register/register'
    | '/artist/$id/chat'
    | '/artist/$id/search'
    | '/artist/$id/profile-info/$clubId'
    | '/artist/$id/profile'
    | '/artist/$id/work-invite/$workInviteId'
    | '/artist/$id/work-request/$workRequestId'
    | '/clubOwner/$id/chat'
    | '/clubOwner/$id/employer/$workItemId'
    | '/clubOwner/$id/profile-info/$profileId'
    | '/clubOwner/$id/profile'
    | '/clubOwner/$id/work-invite/$workInviteId'
    | '/clubOwner/$id/work-request/$workRequestId'
    | '/clubOwner/$id/profile/terms'
    | '/admin/chat/conversation/$conversationId'
    | '/artist/$id/onboard/$step'
    | '/clubOwner/$id/onboard/$step'
    | '/artist/$id/profile/aplications'
    | '/artist/$id/profile/info'
    | '/artist/$id/profile/language'
    | '/artist/$id/profile/loyalty'
    | '/artist/$id/profile/notifications'
    | '/artist/$id/profile/portfolio'
    | '/clubOwner/$id/profile/aplications'
    | '/clubOwner/$id/profile/employers'
    | '/clubOwner/$id/profile/info'
    | '/clubOwner/$id/profile/language'
    | '/clubOwner/$id/profile/loyalty'
    | '/clubOwner/$id/profile/notifications'
    | '/clubOwner/$id/profile/portfolio'
    | '/clubOwner/$id/search'
    | '/artist/$id/profile/'
    | '/clubOwner/$id/profile/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | ''
    | '/privacy-policy'
    | '/admin'
    | '/conversation/$conversationId'
    | '/invite/$inviteId'
    | '/invite/role'
    | '/auth/login'
    | '/artist/$id/current-work'
    | '/admin/artists'
    | '/admin/chat'
    | '/admin/clubs'
    | '/admin/global-events'
    | '/admin/kanban'
    | '/admin/register-requests'
    | '/artist/$id'
    | '/clubOwner/$id'
    | '/auth/forgot-password/confirmation'
    | '/auth/forgot-password/email'
    | '/auth/forgot-password/reset'
    | '/auth/register/confirmation'
    | '/auth/register/register'
    | '/artist/$id/chat'
    | '/artist/$id/search'
    | '/artist/$id/profile-info/$clubId'
    | '/artist/$id/profile'
    | '/artist/$id/work-invite/$workInviteId'
    | '/artist/$id/work-request/$workRequestId'
    | '/clubOwner/$id/chat'
    | '/clubOwner/$id/employer/$workItemId'
    | '/clubOwner/$id/profile-info/$profileId'
    | '/clubOwner/$id/profile'
    | '/clubOwner/$id/work-invite/$workInviteId'
    | '/clubOwner/$id/work-request/$workRequestId'
    | '/clubOwner/$id/profile/terms'
    | '/admin/chat/conversation/$conversationId'
    | '/artist/$id/onboard/$step'
    | '/clubOwner/$id/onboard/$step'
    | '/artist/$id/profile/aplications'
    | '/artist/$id/profile/info'
    | '/artist/$id/profile/language'
    | '/artist/$id/profile/loyalty'
    | '/artist/$id/profile/notifications'
    | '/artist/$id/profile/portfolio'
    | '/clubOwner/$id/profile/aplications'
    | '/clubOwner/$id/profile/employers'
    | '/clubOwner/$id/profile/info'
    | '/clubOwner/$id/profile/language'
    | '/clubOwner/$id/profile/loyalty'
    | '/clubOwner/$id/profile/notifications'
    | '/clubOwner/$id/profile/portfolio'
    | '/clubOwner/$id/search';
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_club'
    | '/privacy-policy'
    | '/admin'
    | '/admin/_admin'
    | '/conversation/$conversationId'
    | '/invite/$inviteId'
    | '/invite/role'
    | '/_auth/auth/login'
    | '/artist/$id/current-work'
    | '/admin/_admin/artists'
    | '/admin/_admin/chat'
    | '/admin/_admin/clubs'
    | '/admin/_admin/global-events'
    | '/admin/_admin/kanban'
    | '/admin/_admin/register-requests'
    | '/artist/$id'
    | '/artist/$id/_artist'
    | '/artist/$id/_onboard'
    | '/clubOwner/$id'
    | '/clubOwner/$id/_club'
    | '/clubOwner/$id/_onboard'
    | '/_auth/auth/forgot-password_/confirmation'
    | '/_auth/auth/forgot-password_/email'
    | '/_auth/auth/forgot-password_/reset'
    | '/_auth/auth/register_/confirmation'
    | '/_auth/auth/register_/register'
    | '/artist/$id/_artist/chat'
    | '/artist/$id/_artist/search'
    | '/artist/$id/profile-info/$clubId'
    | '/artist/$id/profile_'
    | '/artist/$id/profile_/_profile'
    | '/artist/$id/work-invite/$workInviteId'
    | '/artist/$id/work-request/$workRequestId'
    | '/clubOwner/$id/_club/chat'
    | '/clubOwner/$id/employer/$workItemId'
    | '/clubOwner/$id/profile-info/$profileId'
    | '/clubOwner/$id/profile_'
    | '/clubOwner/$id/profile_/_profile'
    | '/clubOwner/$id/work-invite/$workInviteId'
    | '/clubOwner/$id/work-request/$workRequestId'
    | '/clubOwner/$id/profile_/_profile/terms'
    | '/admin/_admin/chat/conversation/$conversationId'
    | '/artist/$id/_artist/profile_'
    | '/artist/$id/_artist/profile_/_profile'
    | '/artist/$id/_onboard/onboard/$step'
    | '/clubOwner/$id/_club/profile_'
    | '/clubOwner/$id/_club/profile_/_profile'
    | '/clubOwner/$id/_onboard/onboard/$step'
    | '/artist/$id/profile_/_profile/aplications'
    | '/artist/$id/profile_/_profile/info'
    | '/artist/$id/profile_/_profile/language'
    | '/artist/$id/profile_/_profile/loyalty'
    | '/artist/$id/profile_/_profile/notifications'
    | '/artist/$id/profile_/_profile/portfolio'
    | '/clubOwner/$id/profile_/_profile/aplications'
    | '/clubOwner/$id/profile_/_profile/employers'
    | '/clubOwner/$id/profile_/_profile/info'
    | '/clubOwner/$id/profile_/_profile/language'
    | '/clubOwner/$id/profile_/_profile/loyalty'
    | '/clubOwner/$id/profile_/_profile/notifications'
    | '/clubOwner/$id/profile_/_profile/portfolio'
    | '/clubOwner/$id/_club/search/'
    | '/artist/$id/_artist/profile_/_profile/'
    | '/clubOwner/$id/_club/profile_/_profile/';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthLazyRoute: typeof AuthLazyRouteWithChildren;
  ClubLazyRoute: typeof ClubLazyRoute;
  PrivacyPolicyLazyRoute: typeof PrivacyPolicyLazyRoute;
  AdminRoute: typeof AdminRouteWithChildren;
  ConversationConversationIdRoute: typeof ConversationConversationIdRoute;
  InviteInviteIdRoute: typeof InviteInviteIdRoute;
  InviteRoleLazyRoute: typeof InviteRoleLazyRoute;
  ArtistIdCurrentWorkRouteRoute: typeof ArtistIdCurrentWorkRouteRoute;
  ArtistIdRoute: typeof ArtistIdRouteWithChildren;
  ClubOwnerIdRoute: typeof ClubOwnerIdRouteWithChildren;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthLazyRoute: AuthLazyRouteWithChildren,
  ClubLazyRoute: ClubLazyRoute,
  PrivacyPolicyLazyRoute: PrivacyPolicyLazyRoute,
  AdminRoute: AdminRouteWithChildren,
  ConversationConversationIdRoute: ConversationConversationIdRoute,
  InviteInviteIdRoute: InviteInviteIdRoute,
  InviteRoleLazyRoute: InviteRoleLazyRoute,
  ArtistIdCurrentWorkRouteRoute: ArtistIdCurrentWorkRouteRoute,
  ArtistIdRoute: ArtistIdRouteWithChildren,
  ClubOwnerIdRoute: ClubOwnerIdRouteWithChildren
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/_club",
        "/privacy-policy",
        "/admin",
        "/conversation/$conversationId",
        "/invite/$inviteId",
        "/invite/role",
        "/artist/$id/current-work",
        "/artist/$id",
        "/clubOwner/$id"
      ]
    },
    "/": {
      "filePath": "index.ts"
    },
    "/_auth": {
      "filePath": "_auth.lazy.tsx",
      "children": [
        "/_auth/auth/login",
        "/_auth/auth/forgot-password_/confirmation",
        "/_auth/auth/forgot-password_/email",
        "/_auth/auth/forgot-password_/reset",
        "/_auth/auth/register_/confirmation",
        "/_auth/auth/register_/register"
      ]
    },
    "/_club": {
      "filePath": "_club.lazy.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.lazy.tsx"
    },
    "/admin": {
      "filePath": "admin",
      "children": [
        "/admin/_admin"
      ]
    },
    "/admin/_admin": {
      "filePath": "admin/_admin.ts",
      "parent": "/admin",
      "children": [
        "/admin/_admin/artists",
        "/admin/_admin/chat",
        "/admin/_admin/clubs",
        "/admin/_admin/global-events",
        "/admin/_admin/kanban",
        "/admin/_admin/register-requests"
      ]
    },
    "/conversation/$conversationId": {
      "filePath": "conversation.$conversationId.ts"
    },
    "/invite/$inviteId": {
      "filePath": "invite.$inviteId.ts"
    },
    "/invite/role": {
      "filePath": "invite.role.lazy.ts"
    },
    "/_auth/auth/login": {
      "filePath": "_auth/auth/login/route.ts",
      "parent": "/_auth"
    },
    "/artist/$id/current-work": {
      "filePath": "artist/$id/current-work/route.tsx"
    },
    "/admin/_admin/artists": {
      "filePath": "admin/_admin/artists.tsx",
      "parent": "/admin/_admin"
    },
    "/admin/_admin/chat": {
      "filePath": "admin/_admin/chat.tsx",
      "parent": "/admin/_admin",
      "children": [
        "/admin/_admin/chat/conversation/$conversationId"
      ]
    },
    "/admin/_admin/clubs": {
      "filePath": "admin/_admin/clubs.tsx",
      "parent": "/admin/_admin"
    },
    "/admin/_admin/global-events": {
      "filePath": "admin/_admin/global-events.tsx",
      "parent": "/admin/_admin"
    },
    "/admin/_admin/kanban": {
      "filePath": "admin/_admin/kanban.tsx",
      "parent": "/admin/_admin"
    },
    "/admin/_admin/register-requests": {
      "filePath": "admin/_admin/register-requests.tsx",
      "parent": "/admin/_admin"
    },
    "/artist/$id": {
      "filePath": "artist/$id",
      "children": [
        "/artist/$id/_artist",
        "/artist/$id/_onboard",
        "/artist/$id/profile-info/$clubId",
        "/artist/$id/profile_",
        "/artist/$id/work-invite/$workInviteId",
        "/artist/$id/work-request/$workRequestId"
      ]
    },
    "/artist/$id/_artist": {
      "filePath": "artist/$id/_artist.ts",
      "parent": "/artist/$id",
      "children": [
        "/artist/$id/_artist/chat",
        "/artist/$id/_artist/search",
        "/artist/$id/_artist/profile_"
      ]
    },
    "/artist/$id/_onboard": {
      "filePath": "artist/$id/_onboard.ts",
      "parent": "/artist/$id",
      "children": [
        "/artist/$id/_onboard/onboard/$step"
      ]
    },
    "/clubOwner/$id": {
      "filePath": "clubOwner/$id",
      "children": [
        "/clubOwner/$id/_club",
        "/clubOwner/$id/_onboard",
        "/clubOwner/$id/employer/$workItemId",
        "/clubOwner/$id/profile-info/$profileId",
        "/clubOwner/$id/profile_",
        "/clubOwner/$id/work-invite/$workInviteId",
        "/clubOwner/$id/work-request/$workRequestId"
      ]
    },
    "/clubOwner/$id/_club": {
      "filePath": "clubOwner/$id/_club.ts",
      "parent": "/clubOwner/$id",
      "children": [
        "/clubOwner/$id/_club/chat",
        "/clubOwner/$id/_club/profile_",
        "/clubOwner/$id/_club/search/"
      ]
    },
    "/clubOwner/$id/_onboard": {
      "filePath": "clubOwner/$id/_onboard.ts",
      "parent": "/clubOwner/$id",
      "children": [
        "/clubOwner/$id/_onboard/onboard/$step"
      ]
    },
    "/_auth/auth/forgot-password_/confirmation": {
      "filePath": "_auth/auth/forgot-password_/confirmation/route.ts",
      "parent": "/_auth"
    },
    "/_auth/auth/forgot-password_/email": {
      "filePath": "_auth/auth/forgot-password_/email/route.ts",
      "parent": "/_auth"
    },
    "/_auth/auth/forgot-password_/reset": {
      "filePath": "_auth/auth/forgot-password_/reset/route.ts",
      "parent": "/_auth"
    },
    "/_auth/auth/register_/confirmation": {
      "filePath": "_auth/auth/register_/confirmation/route.ts",
      "parent": "/_auth"
    },
    "/_auth/auth/register_/register": {
      "filePath": "_auth/auth/register_/register/route.ts",
      "parent": "/_auth"
    },
    "/artist/$id/_artist/chat": {
      "filePath": "artist/$id/_artist/chat.tsx",
      "parent": "/artist/$id/_artist"
    },
    "/artist/$id/_artist/search": {
      "filePath": "artist/$id/_artist/search.ts",
      "parent": "/artist/$id/_artist"
    },
    "/artist/$id/profile-info/$clubId": {
      "filePath": "artist/$id/profile-info.$clubId.ts",
      "parent": "/artist/$id"
    },
    "/artist/$id/profile_": {
      "filePath": "artist/$id/profile_",
      "parent": "/artist/$id",
      "children": [
        "/artist/$id/profile_/_profile"
      ]
    },
    "/artist/$id/profile_/_profile": {
      "filePath": "artist/$id/profile_/_profile.tsx",
      "parent": "/artist/$id/profile_",
      "children": [
        "/artist/$id/profile_/_profile/aplications",
        "/artist/$id/profile_/_profile/info",
        "/artist/$id/profile_/_profile/language",
        "/artist/$id/profile_/_profile/loyalty",
        "/artist/$id/profile_/_profile/notifications",
        "/artist/$id/profile_/_profile/portfolio"
      ]
    },
    "/artist/$id/work-invite/$workInviteId": {
      "filePath": "artist/$id/work-invite.$workInviteId.tsx",
      "parent": "/artist/$id"
    },
    "/artist/$id/work-request/$workRequestId": {
      "filePath": "artist/$id/work-request.$workRequestId.tsx",
      "parent": "/artist/$id"
    },
    "/clubOwner/$id/_club/chat": {
      "filePath": "clubOwner/$id/_club/chat.ts",
      "parent": "/clubOwner/$id/_club"
    },
    "/clubOwner/$id/employer/$workItemId": {
      "filePath": "clubOwner/$id/employer.$workItemId.ts",
      "parent": "/clubOwner/$id"
    },
    "/clubOwner/$id/profile-info/$profileId": {
      "filePath": "clubOwner/$id/profile-info.$profileId.ts",
      "parent": "/clubOwner/$id"
    },
    "/clubOwner/$id/profile_": {
      "filePath": "clubOwner/$id/profile_",
      "parent": "/clubOwner/$id",
      "children": [
        "/clubOwner/$id/profile_/_profile"
      ]
    },
    "/clubOwner/$id/profile_/_profile": {
      "filePath": "clubOwner/$id/profile_/_profile.tsx",
      "parent": "/clubOwner/$id/profile_",
      "children": [
        "/clubOwner/$id/profile_/_profile/terms",
        "/clubOwner/$id/profile_/_profile/aplications",
        "/clubOwner/$id/profile_/_profile/employers",
        "/clubOwner/$id/profile_/_profile/info",
        "/clubOwner/$id/profile_/_profile/language",
        "/clubOwner/$id/profile_/_profile/loyalty",
        "/clubOwner/$id/profile_/_profile/notifications",
        "/clubOwner/$id/profile_/_profile/portfolio"
      ]
    },
    "/clubOwner/$id/work-invite/$workInviteId": {
      "filePath": "clubOwner/$id/work-invite.$workInviteId.ts",
      "parent": "/clubOwner/$id"
    },
    "/clubOwner/$id/work-request/$workRequestId": {
      "filePath": "clubOwner/$id/work-request.$workRequestId.ts",
      "parent": "/clubOwner/$id"
    },
    "/clubOwner/$id/profile_/_profile/terms": {
      "filePath": "clubOwner/$id/profile_/_profile/terms/route.ts",
      "parent": "/clubOwner/$id/profile_/_profile"
    },
    "/admin/_admin/chat/conversation/$conversationId": {
      "filePath": "admin/_admin/chat.conversation.$conversationId.ts",
      "parent": "/admin/_admin/chat"
    },
    "/artist/$id/_artist/profile_": {
      "filePath": "artist/$id/_artist/profile_",
      "parent": "/artist/$id/_artist",
      "children": [
        "/artist/$id/_artist/profile_/_profile"
      ]
    },
    "/artist/$id/_artist/profile_/_profile": {
      "filePath": "artist/$id/_artist/profile_/_profile.tsx",
      "parent": "/artist/$id/_artist/profile_",
      "children": [
        "/artist/$id/_artist/profile_/_profile/"
      ]
    },
    "/artist/$id/_onboard/onboard/$step": {
      "filePath": "artist/$id/_onboard/onboard.$step.ts",
      "parent": "/artist/$id/_onboard"
    },
    "/clubOwner/$id/_club/profile_": {
      "filePath": "clubOwner/$id/_club/profile_",
      "parent": "/clubOwner/$id/_club",
      "children": [
        "/clubOwner/$id/_club/profile_/_profile"
      ]
    },
    "/clubOwner/$id/_club/profile_/_profile": {
      "filePath": "clubOwner/$id/_club/profile_/_profile.tsx",
      "parent": "/clubOwner/$id/_club/profile_",
      "children": [
        "/clubOwner/$id/_club/profile_/_profile/"
      ]
    },
    "/clubOwner/$id/_onboard/onboard/$step": {
      "filePath": "clubOwner/$id/_onboard/onboard.$step.ts",
      "parent": "/clubOwner/$id/_onboard"
    },
    "/artist/$id/profile_/_profile/aplications": {
      "filePath": "artist/$id/profile_/_profile/aplications/route.lazy.ts",
      "parent": "/artist/$id/profile_/_profile"
    },
    "/artist/$id/profile_/_profile/info": {
      "filePath": "artist/$id/profile_/_profile/info/route.lazy.ts",
      "parent": "/artist/$id/profile_/_profile"
    },
    "/artist/$id/profile_/_profile/language": {
      "filePath": "artist/$id/profile_/_profile/language/route.lazy.ts",
      "parent": "/artist/$id/profile_/_profile"
    },
    "/artist/$id/profile_/_profile/loyalty": {
      "filePath": "artist/$id/profile_/_profile/loyalty/route.lazy.ts",
      "parent": "/artist/$id/profile_/_profile"
    },
    "/artist/$id/profile_/_profile/notifications": {
      "filePath": "artist/$id/profile_/_profile/notifications/route.lazy.ts",
      "parent": "/artist/$id/profile_/_profile"
    },
    "/artist/$id/profile_/_profile/portfolio": {
      "filePath": "artist/$id/profile_/_profile/portfolio/route.lazy.ts",
      "parent": "/artist/$id/profile_/_profile"
    },
    "/clubOwner/$id/profile_/_profile/aplications": {
      "filePath": "clubOwner/$id/profile_/_profile/aplications/route.lazy.ts",
      "parent": "/clubOwner/$id/profile_/_profile"
    },
    "/clubOwner/$id/profile_/_profile/employers": {
      "filePath": "clubOwner/$id/profile_/_profile/employers/route.lazy.ts",
      "parent": "/clubOwner/$id/profile_/_profile"
    },
    "/clubOwner/$id/profile_/_profile/info": {
      "filePath": "clubOwner/$id/profile_/_profile/info/route.lazy.tsx",
      "parent": "/clubOwner/$id/profile_/_profile"
    },
    "/clubOwner/$id/profile_/_profile/language": {
      "filePath": "clubOwner/$id/profile_/_profile/language/route.lazy.ts",
      "parent": "/clubOwner/$id/profile_/_profile"
    },
    "/clubOwner/$id/profile_/_profile/loyalty": {
      "filePath": "clubOwner/$id/profile_/_profile/loyalty/route.lazy.tsx",
      "parent": "/clubOwner/$id/profile_/_profile"
    },
    "/clubOwner/$id/profile_/_profile/notifications": {
      "filePath": "clubOwner/$id/profile_/_profile/notifications/route.lazy.ts",
      "parent": "/clubOwner/$id/profile_/_profile"
    },
    "/clubOwner/$id/profile_/_profile/portfolio": {
      "filePath": "clubOwner/$id/profile_/_profile/portfolio/route.lazy.ts",
      "parent": "/clubOwner/$id/profile_/_profile"
    },
    "/clubOwner/$id/_club/search/": {
      "filePath": "clubOwner/$id/_club/search/index.ts",
      "parent": "/clubOwner/$id/_club"
    },
    "/artist/$id/_artist/profile_/_profile/": {
      "filePath": "artist/$id/_artist/profile_/_profile/index.tsx",
      "parent": "/artist/$id/_artist/profile_/_profile"
    },
    "/clubOwner/$id/_club/profile_/_profile/": {
      "filePath": "clubOwner/$id/_club/profile_/_profile/index.tsx",
      "parent": "/clubOwner/$id/_club/profile_/_profile"
    }
  }
}
ROUTE_MANIFEST_END */
